<template>
  <div class="web-profile-container skeleton-mode">
    
    <header class="profile-header">
      <div class="header-info">
        <el-skeleton animated>
          <template #template>
            <el-skeleton-item variant="text" style="width: 180px; height: 14px; margin-bottom: 8px" />
            <el-skeleton-item variant="text" style="width: 140px; height: 14px; display: block;" />
          </template>
        </el-skeleton>
      </div>
      <div class="header-actions">
        <el-skeleton-item variant="rect" style="width: 120px; height: 32px; border-radius: 4px;" />
      </div>
    </header>

    <div class="profile-content">
      
      <section class="card profile-header-section">
        <div class="avatar-column">
          <el-skeleton animated>
            <template #template>
              <el-skeleton-item variant="circle" class="profile-avatar-skeleton" />
              <div style="margin-top: 15px; display: flex; flex-direction: column; align-items: center; gap: 5px; margin-right: 24px;">
                <el-skeleton-item variant="text" style="width: 100px; height: 12px" />
                <el-skeleton-item variant="rect" style="width: 40px; height: 20px; border-radius: 10px" />
              </div>
            </template>
          </el-skeleton>
        </div>

        <div class="details-column">
          <el-skeleton animated style="width: 100%">
            <template #template>
              <div style="margin-bottom: 20px;">
                <el-skeleton-item variant="h1" style="width: 70%; height: 32px; margin-bottom: 10px" />
              </div>

              <div style="margin-bottom: 15px; border-bottom: 1px solid #eee; padding-bottom: 10px;">
                <el-skeleton-item variant="text" style="width: 30%; height: 24px" />
              </div>

              <div class="competencies-skeleton-list">
                <div v-for="n in 3" :key="n" style="margin-bottom: 12px;">
                   <div style="display: flex; justify-content: space-between; margin-bottom: 5px;">
                      <el-skeleton-item variant="text" style="width: 40%" />
                   </div>
                   <el-skeleton-item variant="rect" style="width: 100%; height: 8px; border-radius: 4px;" />
                </div>
              </div>

              <div class="info-row-skeleton">
                 <el-skeleton-item variant="text" style="width: 120px; height: 16px" />
                 <el-skeleton-item variant="text" style="width: 150px; height: 16px" />
              </div>
            </template>
          </el-skeleton>
        </div>
      </section>

      <section class="card section-card">
         <div class="section-title-row">
            <el-skeleton-item variant="h1" style="width: 150px; height: 28px;" />
            <el-skeleton-item variant="circle" style="width: 32px; height: 32px;" />
         </div>
         <div class="section-body">
            <el-skeleton animated>
              <template #template>
                 <el-skeleton-item variant="text" style="width: 100%; height: 14px; margin-bottom: 10px;" />
                 <el-skeleton-item variant="text" style="width: 95%; height: 14px; margin-bottom: 10px;" />
                 <el-skeleton-item variant="text" style="width: 90%; height: 14px; margin-bottom: 10px;" />
                 <el-skeleton-item variant="text" style="width: 60%; height: 14px;" />
              </template>
            </el-skeleton>
         </div>
      </section>

      <section class="card section-card">
         <div class="section-title-row">
            <el-skeleton-item variant="h1" style="width: 150px; height: 28px;" />
            <el-skeleton-item variant="circle" style="width: 32px; height: 32px;" />
         </div>
         <div class="section-body">
            <el-skeleton animated>
              <template #template>
                 <el-skeleton-item variant="text" style="width: 100%; height: 14px; margin-bottom: 10px;" />
                 <el-skeleton-item variant="text" style="width: 95%; height: 14px; margin-bottom: 10px;" />
                 <el-skeleton-item variant="text" style="width: 90%; height: 14px; margin-bottom: 10px;" />
                 <el-skeleton-item variant="text" style="width: 60%; height: 14px;" />
              </template>
            </el-skeleton>
         </div>
      </section>

      <section class="card section-card">
         <div class="section-title-row">
            <el-skeleton-item variant="h1" style="width: 150px; height: 28px;" />
            <el-skeleton-item variant="circle" style="width: 32px; height: 32px;" />
         </div>
         <div class="section-body">
            <el-skeleton animated>
              <template #template>
                 <el-skeleton-item variant="text" style="width: 100%; height: 14px; margin-bottom: 10px;" />
                 <el-skeleton-item variant="text" style="width: 95%; height: 14px; margin-bottom: 10px;" />
                 <el-skeleton-item variant="text" style="width: 90%; height: 14px; margin-bottom: 10px;" />
                 <el-skeleton-item variant="text" style="width: 60%; height: 14px;" />
              </template>
            </el-skeleton>
         </div>
      </section>

    </div>
  </div>
</template>

<script>
export default {
  name: "WebProfileSkeleton",
};
</script>

<style scoped>
.web-profile-container {
  display: flex;
  flex-direction: column;
  height: 100%;
  background-color: #f5f7fa; 
  background-color: #ededed;
}

.profile-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #ffffff;
  border-bottom: 1px solid #e4e7ed;
  padding: 0 20px;
  height: 60px;
  flex-shrink: 0;
  margin: 0 20px 0 20px;
  border: 1px solid #ddd;
  border-radius: 8px;
  background-color: #fff;
}

.header-info {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.profile-content {
  display: flex;
  flex-direction: column;
  padding: 20px;
  flex-grow: 1;
  overflow-y: hidden; 
  gap: 20px;
  background: #ededed;
}

.card {
  background-color: #fff;
  border: 1px solid #ddd;
  border-radius: 8px;
  padding: 1.5rem;
}

.profile-header-section {
  display: grid;
  grid-template-columns: 180px 1fr;
  grid-template-rows: auto;
  gap: 1rem 2rem;
}

.avatar-column {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.profile-avatar-skeleton {
  width: 150px; 
  height: 150px;
}

.details-column {
  display: flex;
  flex-direction: column;
  width: 100%;
}

.info-row-skeleton {
  display: flex;
  gap: 2rem;
  margin-top: 1.5rem;
  padding-top: 1rem;
  border-top: 1px solid #eee;
}

/* Generic Section Styles */
.section-card {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.section-title-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.5rem;
}
</style>